import PropTypes from 'prop-types';

import styles from './SetupLayout.module.scss';

const SetupLayout = ({ children }) => <section className={styles.setupLayout}>{children}</section>;

SetupLayout.propTypes = {
  children: PropTypes.node,
};

SetupLayout.defaultProps = {
  children: <div />,
};

export default SetupLayout;
